/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.getPublicQrCodeScanToken.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class GetPublicQrCodeScanTokenResponseModel(
    @SerialName("expires_in")
    val expiresIn: Int?,

    @SerialName("token_type")
    val tokenType: String?,

    @SerialName("access_token")
    val accessToken: String?
) : Model()
